<template>
  <div>
    <b-card class="w-100" header-tag="header">
      <template #header>
        <h4 class="mb-0">Representación Gráfica / Resumen General</h4>
        <b-button
          variant="primary"
          @click="myCharges"
        >
          Mis transacciones
        </b-button>
      </template>
      <hr class="p-0 m-0">
      <div class="row">
        <div class="col-lg-2 col-md-4">
          <DoughnutChart
            v-if="totalFolders || totalFiles"
            :totalFolders="totalFolders"
            :totalFiles="totalFiles"
          />
        </div>
        <div
          :class="{
            'col-12': !totalFolders && !totalFiles,
            'col-10': totalFolders || totalFiles
          }"
        >
          <table class="table text-center mt-5">
            <thead>
              <tr>
                <th>Descripción</th>
                <th>Cantidad</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <b-badge variant="success">Archivos</b-badge>
                </td>
                <td> {{totalFiles}} </td>
              <tr>
                <td>
                  <b-badge variant="warning">Carpetas</b-badge>
                </td>
                <td> {{totalFolders}} </td>
              </tr>
              <tr>
                <td> Total: </td>
                <td> {{totalFilesPlusFolders}} </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import DoughnutChart from '@/febos/global/operations/components/transactionality/DoughnutChart';

export default {
  name: 'GeneralSummary',
  components: { DoughnutChart },
  computed: {
    ...mapGetters('Operations', ['transaccionality']),
    ...mapGetters('Empresas', ['company']),
    holdingEnterprises() {
      return this.transaccionality.map((t) => ({
        enterprise: t.razonSocial,
        iut: t.iut,
        totalTransactions: t.transacciones.total,
        totalStorage: t.almacenamiento.total,
        totalApprovals: t.aprobaciones.total,
        totalSigns: t.totalFirmas,
        approvals: t.aprobaciones,
        transactions: t.transacciones,
        storage: t.almacenamiento,
        monthlyReport: t.reporteMensual,
        detailReport: t.reporteDetalle
      }));
    },
    totalFiles() {
      let total = 0;
      this.transaccionality.forEach((t) => {
        total += t.totalArchivos;
      });
      return total;
    },
    totalFolders() {
      let total = 0;
      this.transaccionality.forEach((t) => {
        total += t.totalCarpetas;
      });
      return total;
    },
    totalFilesPlusFolders() {
      return this.totalFolders + this.totalFiles;
    }
  },
  methods: {
    ...mapActions('Operations', ['getTransaccionality']),
    async myCharges(selectedPeriod) {
      console.log(selectedPeriod);
      const data = await this.getTransaccionality({
        params: {
          filtros: `iut:${this.company.iut}`,
          periodo: selectedPeriod.filter,
          paginaActual: this.page,
          elementosPorPagina: 100000,
        }
      });
      let selectedItem = data.empresas.find((item) => item.iut === this.company.iut);
      selectedItem = {
        ...selectedItem,
        transactions: selectedItem.transacciones,
        storage: selectedItem.almacenamiento,
        approvals: selectedItem.aprobaciones,
        totalSigns: selectedItem.totalFirmas
      };
      this.filteredData = selectedItem;
      this.$router.push({
        name: 'holdingDetail',
        params: {
          enterpriseId: this.company.iut,
          data: selectedItem
        },
      });
    }
  }
};
</script>
